import { render, staticRenderFns } from "./SignUpLink.vue?vue&type=template&id=193c39f8&"
import script from "./SignUpLink.vue?vue&type=script&lang=js&"
export * from "./SignUpLink.vue?vue&type=script&lang=js&"
import style0 from "./SignUpLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports